import { Vue, newVue } from '@/config/vue'

const defaultSelector = '.js-vue-minicart-recommendation'

var isInitialized = false

const init = ({ el }) => {
  if (isInitialized) return
  const MiniCartRec = Vue.component('mini-cart-rec', () =>
    import(/* webpackChunkName: "mini-cart-rec" */ './MiniCartRec.vue')
  )
  newVue({
    render: h => h(MiniCartRec),
    mount: el || defaultSelector,
  })
  isInitialized = true
}

const initDelayedCallback = () => {
  On.DynamicYield.delayedCallback(() => init({ el: defaultSelector }), 'minicart-rec')
}

window.addEventListener('on:navigation-ready', initDelayedCallback)
window.On.MiniCartRecommendationVueInit = init
